// extracted by mini-css-extract-plugin
export var icon = "_rb-0";